import { useEffect } from 'react';
import fetchProjects from './fetchProjects';

export default function useFetchProjects() {
  useEffect(() => {
    fetchProjects();
  }, []);
}
